/**
 * What a professional always needs to know before they can quote anything.
 *
 * Their own list, written by them -- the assistant asks it of the customer
 * alongside whatever it works out from the job itself. See
 * AssistantGuideEditor for why it is never shown as a blank box.
 */
export interface IAssistantGuide {
  questions: string[];

  /**
   * True while these are the shared defaults rather than their own. The one
   * thing the screen needs it for: saying "these are the usual ones, change
   * what you like" instead of pretending somebody wrote them.
   */
  isDefault: boolean;
}

/** Same ceilings the backend enforces -- see AssistantGuideDefaults. */
export const ASSISTANT_GUIDE_MAX_QUESTIONS = 8;
export const ASSISTANT_GUIDE_MAX_QUESTION_LENGTH = 200;
